// AppContext.js
import React, {
  createContext,
  useState,
  useEffect,
  useRef,
  useContext,
} from "react";
import axios from "axios";

import { MyDomain } from "./App";

// Create the context
export const AppContext = createContext();

// Create a provider component
export const AppProvider = ({ children }) => {
  const storedUser = JSON.parse(localStorage.getItem("user")) ?? null;
  const storedToken = localStorage.getItem("token") ?? null;
  //const lang = JSON.parse(localStorage.getItem("lang")) ?? null;
  const lang = JSON.parse(localStorage.getItem("lang")) ?? JSON.stringify("en");

  const [User, setUser] = useState(storedUser);
  const [Token, setToken] = useState(storedToken);
  const [Lang, setLang] = useState(lang);

  const user = JSON.parse(localStorage.getItem("user")) ?? null;

  const cartAmount = JSON.parse(localStorage.getItem("cartAmount")) ?? [];
  const [CartAmount, setCartAmount] = useState(cartAmount); // Shared state for the number
  const wishList = JSON.parse(localStorage.getItem("wishList")) ?? [];
  const [WishList, setWishList] = useState(wishList); // Shared state for the number
  const [OpenLoginPopOver, setOpenLoginPopOver] = useState(false); // Shared state for the number

  const [
    CheckIfHaveAddressToCouldClickBuy,
    setCheckIfHaveAddressToCouldClickBuy,
  ] = useState(false); // Shared state for the number

  const handleOpenLoginPopOver = (newOpen) => {
    setOpenLoginPopOver(newOpen);
  };
  useEffect(() => {
    GetUserWishList();
  }, []);

  const GetUserWishList = (event) => {
    const data = {
      Id: user?.userId,
    };
    axios
      .post(`${MyDomain}Users/GetUserById`, data) // replace with your API URL
      .then((response) => {
        //console.log(response.data);
        setWishList(response.data.wishListItems);
        setCartAmount(response.data.cartItems.length);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };

  return (
    <AppContext.Provider
      value={{
        User,
        setUser,
        Token,
        setToken,
        WishList,
        setWishList,
        CartAmount,
        setCartAmount,
        OpenLoginPopOver,
        setOpenLoginPopOver,
        handleOpenLoginPopOver,
        Lang,
        setLang,
        CheckIfHaveAddressToCouldClickBuy,
        setCheckIfHaveAddressToCouldClickBuy,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
export const useAppContext = () => useContext(AppContext);
